import { connect } from "react-redux";
import { getMostRecentMessage } from "../../../reduxV2/chats/chat.selectors";
import ChatListItem from "./ChatListItem";
var mapStateToProps = function (state, props) { return ({
    mostRecentMessage: getMostRecentMessage(state, props.chat.id),
}); };
// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps)(ChatListItem);
